import React, { useEffect, useState } from "react";
import Header from "../../../../layout/header";
import BottomMenu from "../../../../layout/bottomMenu";
import "../../../../Dashboard/Dashboard.css";
import "../../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileUpload from "../../../../FileUploads/FileUpload";
import "./payout-details.css";
import SuccessModal from "../../../../CustomModal/Success";

const PayoutDetails = ({
  match,
  history,
  documentUploadUrlPublic,
  documentUrlDataPublic = [],
  updateThePayoutDetails,
  updatePayoutDetails = [],
  getPayoutDetailsUsingId,
  getPayoutDetailsUsingLoanId = [],
}) => {
  const [inputList, setInputList] = useState([
    {
      modification_payout_amount: "",
      modification_payout_percentage: "",
      upload_approval_document: "",
      modificationButton: false,
    },
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const [payoutAmount, setPayoutAmount] = useState(0);
  const [payoutPercentage, setPayoutPercentage] = useState(0);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const handleInput = (value, field, index) => {
    const updatedInputList = [...inputList];

    // Update the input list based on the field being changed
    updatedInputList[index][field] = value;

    // Auto-calculate modification_payout_percentage if modification_payout_amount is entered
    if (field === "modification_payout_amount" && getPayoutDetailsUsingLoanId?.loan_approved_amount) {
      const modificationPayoutAmount = parseFloat(value) || 0;
      const loanApprovedAmount = parseFloat(getPayoutDetailsUsingLoanId?.loan_approved_amount) || 1; 
      const modificationPayoutPercentage = (modificationPayoutAmount / loanApprovedAmount) * 100;

      // Set the calculated percentage
      updatedInputList[index]["modification_payout_percentage"] = modificationPayoutPercentage.toFixed(2); 
    }

    // Auto-calculate modification_payout_amount if modification_payout_percentage is entered
    if (field === "modification_payout_percentage" && getPayoutDetailsUsingLoanId?.loan_approved_amount) {
      const modificationPayoutPercentage = parseFloat(value) || 0;
      const loanApprovedAmount = parseFloat(getPayoutDetailsUsingLoanId?.loan_approved_amount) || 1; 
      const modificationPayoutAmount = (modificationPayoutPercentage * loanApprovedAmount) / 100;

      // Set the calculated payout amount
      updatedInputList[index]["modification_payout_amount"] = modificationPayoutAmount.toFixed(2);
    }

    setInputList(updatedInputList);
  };

  const handleModification = (index) => {
    const updatedInputList = [...inputList];
    updatedInputList[index].modificationButton = true;
    setInputList(updatedInputList);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getPayoutDetailsUsingId(match?.params?.id);
      setIsLoading(false);
    })();
  }, [getPayoutDetailsUsingId]);

  useEffect(() => {
    // if (
    //   Array.isArray(getPayoutDetailsUsingLoanId?.track) &&
    //   getPayoutDetailsUsingLoanId.track.length > 0
    // ) {
    //   setPayoutAmount(getPayoutDetailsUsingLoanId.track[0].payout_amount);
    //   setPayoutPercentage(
    //     getPayoutDetailsUsingLoanId.track[0].payout_percentage
    //   );
    // }

    if(getPayoutDetailsUsingLoanId){
      setPayoutAmount(getPayoutDetailsUsingLoanId?.final_payout_amount);
      setPayoutPercentage(getPayoutDetailsUsingLoanId?.final_payout_percentage);
    }
  }, [getPayoutDetailsUsingLoanId]);

  const handleAccept = async () => {
    inputList[0]["action"] = "accept";
    inputList[0]["modification_payout_amount"] = payoutAmount;
    inputList[0]["modification_payout_percentage"] = payoutPercentage;
    inputList[0]["loan_application_id"] = parseInt(match?.params?.id);

    setIsLoading(true);
    const res = await updateThePayoutDetails(inputList);
    console.log("RES: ", res);
    if (res.status == true) {
      setIsSuccessModalOpen(true);
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    inputList[0]["action"] = "modify";
    // inputList[0]["modification_payout_amount"] = payoutAmount;
    // inputList[0]["modification_payout_percentage"] = payoutPercentage;
    inputList[0]["loan_application_id"] = parseInt(match?.params?.id);

    setIsLoading(true);
    const res = await updateThePayoutDetails(inputList);
    console.log("RES: ", res);
    if (res.status == true) {
      setIsSuccessModalOpen(true);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={"Payout updated successfully"}
        url={"ucd-approval-list"}
      />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Payout Details"} history={history} />
            <div>
              <div className="container-fluid">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="card-body">
                    {inputList.map((input, index) => (
                      <>
                        <div key={index} className="user mt-3">
                          {getPayoutDetailsUsingLoanId?.status ==
                          "Default Generated" ? (
                            <>
                              <p style={{ color: "black" }}>
                                <b>Commission based on case details:</b>
                              </p>
                              <div className="payout-form-group row">
                                <div className="col-md-6">
                                  <label className="large-label">
                                    Payout Amount{" "}
                                    <i className="bi bi-asterisk payout-astrick-icon"></i>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder=" "
                                    value={payoutAmount}
                                    required
                                    disabled
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="large-label">
                                    Payout Percentage{" "}
                                    <i className="bi bi-asterisk payout-astrick-icon"></i>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder=" "
                                    value={payoutPercentage}
                                    required
                                    disabled
                                  />
                                </div>
                              </div>

                              {!input.modificationButton && (
                                <div className="d-flex mb-5">
                                  <button
                                    type="button"
                                    onClick={() => handleAccept(index)}
                                    className="btn btn-sm btn-success mr-3"
                                  >
                                    Accept
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleModification(index)}
                                    className="btn btn-sm btn-warning"
                                  >
                                    Modify
                                  </button>
                                </div>
                              )}

                              {input.modificationButton && (
                                <>
                                  <p style={{ color: "black" }}>
                                    <b>Modification in payout:</b>
                                  </p>
                                  <div className="payout-form-group row">
                                    <div className="col-md-6">
                                      <label className="large-label">
                                        Payout Amount{" "}
                                        <i className="bi bi-asterisk payout-astrick-icon"></i>
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=" "
                                        value={input.modification_payout_amount} 
                                        onChange={(e) => {
                                          handleInput(
                                            e.target.value,
                                            "modification_payout_amount",
                                            index
                                          );
                                        }}
                                        required
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <label className="large-label">
                                        Payout Percentage{" "}
                                        <i className="bi bi-asterisk payout-astrick-icon"></i>
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=" "
                                        value={input.modification_payout_percentage} 
                                        onChange={(e) => {
                                          handleInput(
                                            e.target.value,
                                            "modification_payout_percentage",
                                            index
                                          );
                                        }}
                                        required
                                      />
                                    </div>
                                  </div>
                                  <div className="payout-form-group row">
                                    <div className="col-md-6">
                                      <label className="large-label">
                                        Upload Approval{" "}
                                        <i className="bi bi-asterisk payout-astrick-icon"></i>
                                      </label>
                                      <FileUpload
                                        id={`addAttachment-${index}`}
                                        accept=".png,.jpg,.jpeg,.pdf,.doc"
                                        documentUploadUrl={
                                          documentUploadUrlPublic
                                        }
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(file) => {
                                          handleInput(
                                            file,
                                            "upload_approval_document",
                                            index
                                          );
                                        }}
                                        required={true}
                                        prefilledFilename={
                                          input.upload_approval_document
                                            ? "Attachment"
                                            : ""
                                        }
                                      ></FileUpload>
                                    </div>
                                  </div>
                                  <div className="d-flex">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                      Submit
                                    </button>
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            getPayoutDetailsUsingLoanId?.track?.length > 0 && (
                              <>
                                <div class="highlight-badge">
                                  {getPayoutDetailsUsingLoanId?.status}
                                </div>
                                <br />
                                <br />

                                {getPayoutDetailsUsingLoanId.track.map(
                                  (trackItem, idx) => (
                                    <div className="payout-form-group row" key={idx}>
                                      <div className="col-md-12">
                                        {trackItem?.status !==
                                          "DEFAULT_GENERATED" && (
                                          <p style={{ color: "black" }}>
                                            <b>{trackItem?.text}</b>
                                          </p>
                                        )}
                                      </div>

                                      <div className="col-md-5">
                                        <label className="large-label">
                                          Payout Amount{" "}
                                          <i className="bi bi-asterisk payout-astrick-icon"></i>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=" "
                                          value={trackItem?.payout_amount}
                                          disabled
                                          required
                                        />
                                      </div>
                                      <div className="col-md-5">
                                        <label className="large-label">
                                          Payout Percentage{" "}
                                          <i className="bi bi-asterisk payout-astrick-icon"></i>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder=" "
                                          value={
                                            trackItem?.payout_percentage
                                          }
                                          disabled
                                          required
                                        />
                                      </div>

                                      {trackItem?.payout_modification_proof_url !==
                                        null && (
                                        <div className="col-md-2">
                                          <label className="large-label">
                                            Upload Approval{" "}
                                            <i className="bi bi-asterisk payout-astrick-icon"></i>
                                          </label>
                                          <a
                                            className="btn btn-primary btn-sm"
                                            target="_blank"
                                            href={
                                              trackItem?.payout_modification_proof_url
                                            }
                                          >
                                            <i class="bi bi-download"></i>{" "}
                                            Download
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                                {getPayoutDetailsUsingLoanId?.final_status === 'PAYOUT_COMPLETED' && (
                                  <div className="payout-form-group row">
                                    <div className="col-md-5">
                                      <label className="large-label">
                                        UTR No.{" "}
                                        <i className="bi bi-asterisk payout-astrick-icon"></i>
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder=" "
                                        value={getPayoutDetailsUsingLoanId?.utr}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            )
                          )}
                        </div>
                      </>
                    ))}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <BottomMenu />
      </div>
    </>
  );
};

export default PayoutDetails;
